import { useQuery, UseQueryResult } from '@tanstack/react-query';
import axios from 'lib/axios';

export const useAnalyticsMetrics = (params = {}): UseQueryResult<any[]> => {
	return useQuery({
		queryKey: ['metrics', params],
		queryFn: async() => {
			const { data } = await axios.get('/analytics', { params });
			return data;
		}
	});
};